<template>
    <!-- 送料無料ライン表示パーツ -->
    <div class="pt055" id="pt055" v-cloak>
        <div>
            <span v-if="checkFreeLine()" v-html="pt055DescriptionInfo[1]"/>
            <!-- 送料無料ライン表示 カート内商品の温度帯分のみ表示 送料無料ラインが無い場合非表示 -->
            <div class="soryoFreeLine mb-2">
                <div v-for="(ondoInfo, index) in pt055Init.cartInfoList" :key="index" :class="'gageContainer gageContainer_'+ ondoInfo.ONDO_KBN">
                    <template v-if="ondoInfo.FREE_LINE > 0">
                        <!-- 温度帯商品：あと〇〇円で送料無料 -->
                        <div class="soryoFreeText">
                            <span :class="'ondoKbn ondoKbn_'+ ondoInfo.ONDO_KBN">{{ondoInfo.ONDO_NM}}{{$t('pt055.labels.item')}}{{$t('common.labels.colon')}}</span>
                            <template v-if="setLeftKin(ondoInfo.SALE_ZEI_K_TNK, ondoInfo.SALE_TNK, ondoInfo.FREE_LINE) > 0">
                                <span :class="'limitText limitText_'+ ondoInfo.ONDO_KBN">{{$t('pt055.labels.limitText[0]')}}</span>
                                <span :class="'limitKin limitKin_'+ ondoInfo.ONDO_KBN">{{setLeftKin(ondoInfo.SALE_ZEI_K_TNK, ondoInfo.SALE_TNK, ondoInfo.FREE_LINE)}}{{$t('common.labels.jpYen')}}</span>
                                <span :class="'limitText limitText_'+ ondoInfo.ONDO_KBN">{{$t('pt055.labels.limitText[1]')}}</span>
                            </template>
                            <template v-else>
                                <span :class="'limitText limitText_'+ ondoInfo.ONDO_KBN">{{$t('pt055.labels.soryoFree')}}</span>
                            </template>
                        </div>
                        <!-- 送料無料までの金額 -->
                        <div class="materGage">
                            <meter :value="zeiDspKbn=='1'?ondoInfo.SALE_ZEI_K_TNK:ondoInfo.SALE_TNK" min="0" :max="ondoInfo.FREE_LINE"/>
                        </div>
                        <div class="divGage">
                            <div class="gageOutline">
                                <div class="gageFill" :style="{width: setGageValue(ondoInfo.SALE_ZEI_K_TNK, ondoInfo.SALE_TNK, ondoInfo.FREE_LINE) + '%'}">
                                </div>
                            </div>
                        </div>
                    </template>
                </div>
            </div>
            <span v-if="checkFreeLine()" v-html="pt055DescriptionInfo[2]"/>
        </div>
    </div>
</template>

<script>
/* eslint-disable */
/*
* Import libs and componnents
*/
import $ from 'jquery';
import axios from "assets/js/request";
import common from 'assets/js/common';

export default {
    /*
    * Name of component
    */
    name: "pt055",
    props:{
        evtChangeQtyFlg: {
            type: Boolean,
            default: false,
        },
        ptInitData: {
            type: Object,
            default: null,
        },
    },
    /* 
    * Declare components
    */
    components: {

    },
    /*
    * Declare variable and set default value
    */
    data: function() {
        return {
            pt055ReqModel:{},
            pt055Init:{
                cartInfoList: []
            },
            pt055DescriptionInfo: {},
            zeiDspKbn: '1',
            leftKin: 0
        }
    },
    /*
    * Initialize
    */
    mounted: async function() {
        var _this = this;

        if (_this.ptInitData){
            _this.pt055Init = _this.ptInitData;
            _this.zeiDspKbn = _this.pt055Init.zeiDspKbn;
            _this.pt055DescriptionInfo = _this.pt055Init.pt055DescriptionInfo;
        }else{
            _this.init();
        }
    },
    /*
    * Methods
    */
    methods: {
        // 初期化
        init: function(){
            var _this = this;
            axios.post(_this.$UrlConstants.ECSITE + _this.$UrlConstants.PT055 + _this.$UrlConstants.DO_INIT).then(function(response) {
                _this.pt055Init = response.data;
                _this.zeiDspKbn = _this.pt055Init.zeiDspKbn;
                _this.pt055DescriptionInfo = _this.pt055Init.pt055DescriptionInfo;
                console.log(_this.pt055Init);
            }).catch(function(error) {
                common.errorAPI(error);
            });
        },

        // 送料無料までの金額
        setLeftKin: function(saleZeiTnk, saleTnk, freeLine){
            var _this = this;
            var leftKin = 0;
            if (_this.zeiDspKbn == '1'){
                leftKin = saleZeiTnk;
            }else{
                leftKin = saleTnk;
            }
            leftKin = freeLine - leftKin;
            return leftKin;
        },

        // ゲージの値 div用
        setGageValue : function(saleZeiTnk, saleTnk, freeLine){
            var _this = this;
            var leftKin = 0;
            if (_this.zeiDspKbn == '1'){
                leftKin = saleZeiTnk;
            }else{
                leftKin = saleTnk;
            }
            if (leftKin > freeLine){
                leftKin = freeLine;
            }

            var gageValue = 0;
            if (leftKin > 0){
                gageValue = (leftKin / freeLine) * 100;
            }else{
                gageValue = 0;
            }
            return gageValue;
        },

        // 送料無料ライン存在チェック
        checkFreeLine : function(){
            var _this = this;
            var checkFlg = false;
            for (var i = 0; i < _this.pt055Init.cartInfoList.length; i++){
                if (_this.pt055Init.cartInfoList[i].FREE_LINE > 0){
                    checkFlg = true;
                    break;
                }
            }
            return checkFlg;
        }
    },
    watch: {
        /* eslint-disable */
        /**
         * get event change item order
         * @param {any} newVal, 
         * @param {any} oldVal
         */
        evtChangeQtyFlg(newVal, oldVal) {
            this.init();
        }
    },
    created() {

    }
}
</script>